var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("About")]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.push('/signup')}}},[_vm._v("Get Started")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }